import qs from "qs";
import _ from "lodash";
import DOMPurify from 'dompurify';
import FetchHelper from "./lib/fetchHelper.js";
import React from "react";
import ShiftExchangeComponent from "./ShiftExchangeComponent";
import DateSelectorComponent from "./componentlib/dateselector/DateSelectorComponent";
import SwipeNavigation from "./lib/swipeNavigation";
import MemberDialog from "./lib/memberDialog";
import DateUtility from "./lib/dateUtility";
import { linkifyHtml } from "./lib/linkify";
import AcquireShift, { overtagQuestion, tagVagtenQuestion, whenText } from "./lib/acquireShift";
import { SWAP_CHANGED_EVENT, udbydSummary } from "./lib/swapShiftLine";
import { DateTime } from "luxon";
import { ReactRenderer } from "./lib/ReactRenderer";
import { BPShiftStatus } from "./lib/bpShiftStatus";
// What a member with no photo has instead (BioPlannerConstants.EmptyProfileImage): the dialog shows
// the initials then, not this picture.
const Icon = ({ children, size = 18, stroke = 1.75 }) => (React.createElement("svg", { viewBox: "0 0 24 24", width: size, height: size, fill: "none", stroke: "currentColor", strokeWidth: stroke, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", style: { flex: "none" } }, children));
/** The ticket sales of one showing, as a bar; they are fetched again every minute while the page is open. */
class TicketBar extends React.Component {
    constructor(props) {
        super(props);
        this.load = () => {
            FetchHelper.get(`/bpapi/eventinfo/${this.props.eventId}/tickets`)
                .then((sales) => this.setState({ sales, failed: false }))
                .catch(() => this.setState({ failed: true }));
            this.token = setTimeout(this.load, 60000);
        };
        this.state = { sales: null, failed: false };
    }
    componentDidMount() { this.load(); }
    componentWillUnmount() { clearTimeout(this.token); }
    render() {
        const sales = this.state.sales;
        if (!sales) {
            return this.state.failed ? React.createElement("div", { className: "bi-vi-tickets-none" }, "Billetsalg kunne ikke hentes") : null;
        }
        const total = sales.sold + sales.prebooked + sales.free;
        const pct = (n) => (total > 0 ? (n / total) * 100 : 0);
        return (React.createElement("div", { className: "bi-vi-tickets" },
            React.createElement("div", { className: "bi-vi-tickets-line" },
                React.createElement("span", { className: "bi-vi-label" }, "Billetsalg"),
                React.createElement("span", null,
                    React.createElement("strong", null, sales.sold),
                    " solgte"),
                React.createElement("span", { className: "bi-vi-tickets-rest" },
                    sales.prebooked,
                    " reserverede \u00B7 ",
                    sales.free,
                    " ledige")),
            React.createElement("div", { className: "bi-vi-bar", role: "img", "aria-label": `${sales.sold} solgte, ${sales.prebooked} reserverede og ${sales.free} ledige af ${total} pladser` },
                React.createElement("span", { className: "bi-vi-bar-sold", style: { width: `${pct(sales.sold)}%` } }),
                React.createElement("span", { className: "bi-vi-bar-booked", style: { width: `${pct(sales.prebooked)}%` } }))));
    }
}
/** The answer of a volunteer on the shift: a pill, which on the volunteer's own row is the button that changes it. */
const RsvpPill = ({ member, editable, busy, onSelect }) => {
    const [open, setOpen] = React.useState(false);
    const kind = member.rsvp === 1 ? "yes" : member.rsvp === 2 ? "no" : "none";
    const label = member.rsvp === 1 ? "Kommer" : member.rsvp === 2 ? "Kommer ikke" : "Ikke svaret";
    const pill = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: `bi-rsvp bi-rsvp-${kind}`, role: "img", "aria-label": label, title: label }),
        label));
    if (!editable) {
        return React.createElement("span", { className: `bi-vi-pill bi-vi-pill-${kind}` }, pill);
    }
    return (React.createElement("span", { className: "bi-vi-pill-menu" },
        React.createElement("button", { type: "button", className: `bi-vi-pill bi-vi-pill-${kind} bi-vi-pill-button`, disabled: busy, "aria-haspopup": "menu", "aria-expanded": open, onClick: () => setOpen(!open) },
            pill,
            React.createElement(Icon, { size: 14, stroke: 2.25 },
                React.createElement("path", { d: "m6 9 6 6 6-6" }))),
        open
            ? React.createElement("ul", { className: "bi-vi-menu", role: "menu" },
                React.createElement("li", null,
                    React.createElement("button", { type: "button", role: "menuitem", onClick: () => { setOpen(false); onSelect(1); } }, "P\u00E5 vagt")),
                React.createElement("li", null,
                    React.createElement("button", { type: "button", role: "menuitem", onClick: () => { setOpen(false); onSelect(2); } }, "Ikke p\u00E5 vagt")))
            : null));
};
export default class ShiftInformationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.swipeRef = React.createRef();
        this.navigating = false;
        // A shift was taken from here (or elsewhere): the people on the page are no longer the same.
        this.reload = () => {
            if (this.state.shift)
                this.loadShiftInformation(this.state.shift.shift.id);
        };
        this.onUpdateRSVP = (shiftMemberId, rsvpStatus) => {
            this.setState({ busyRsvp: true });
            FetchHelper.put(`/bpapi/shiftinfo/${shiftMemberId}/rsvp/${rsvpStatus}`, {})
                .then((result) => {
                const members = _.filter(this.state.shop, (x) => x.id !== shiftMemberId);
                members.push(result);
                this.setState({ shop: _.sortBy(members, (x) => x.name) });
            })
                .finally(() => {
                this.setState({ busyRsvp: false });
            });
        };
        this.loadShiftInformation = (shiftId) => {
            FetchHelper.get(`/bpapi/shiftinfo/${(shiftId) ? shiftId : ''}`)
                .then((result) => {
                window.history.replaceState(null, null, qs.stringify({ shiftId: result.shift.id }, { addQueryPrefix: true }));
                this.updateStateAfterLoad(result);
            })
                .catch((error) => this.onLoadFailed(error, !!shiftId));
        };
        this.loadShiftInformationByDate = (dt) => {
            FetchHelper.get(`/bpapi/shiftinfo/?dt=${dt}`)
                .then((result) => {
                window.history.replaceState(null, null, qs.stringify({ shiftId: result.shift.id }, { addQueryPrefix: true }));
                this.updateStateAfterLoad(result);
            })
                .catch((error) => this.onLoadFailed(error, false));
        };
        // Without this the page sat on the spinner for ever. FetchHelper rejects with the status line,
        // so a 404 is told apart from everything else: a shift that was asked for by id and is gone
        // (deleted since the link was made), no shift at all to show, or a failure.
        this.onLoadFailed = (error, askedForAShift) => {
            console.error(error);
            // A shift is already on screen (Forrige, Næste or the date picker led nowhere): keep it.
            if (this.state.isLoaded)
                return;
            const notFound = `${error}`.startsWith('404');
            this.setState({
                isLoaded: false,
                loadError: !notFound ? 'failed' : (askedForAShift ? 'shiftnotfound' : 'noshifts')
            });
        };
        this.updateStateAfterLoad = (result, callback) => {
            this.setState({
                isLoaded: true,
                loadError: null,
                shift: result,
                shop: _.sortBy(result.shift.shop, (x) => x.name),
                pastShift: DateTime.fromISO(result.shift.dtEnd) < DateTime.now()
            }, callback);
        };
        const search = qs.parse(location.search, { ignoreQueryPrefix: true });
        this.state = {
            isLoaded: false,
            shiftId: search.shiftId,
            selectedMember: null,
            // The question of Overtag or Tag vagten, while it is open.
            confirmTake: null,
            shop: []
        };
    }
    componentDidMount() {
        this.loadShiftInformation(this.state.shiftId);
        window.addEventListener(SWAP_CHANGED_EVENT, this.reload);
    }
    componentWillUnmount() {
        window.removeEventListener(SWAP_CHANGED_EVENT, this.reload);
    }
    navigate(shiftId) {
        this.loadShiftInformation(shiftId);
    }
    // Forrige (-1) and Næste (1), from the buttons or a swipe. The shift on screen slides out
    // while the next one is fetched, and that one slides in from the other side. One step at a
    // time: a second swipe before the first has landed is dropped.
    step(dir) {
        const shiftId = dir > 0 ? this.state.shift.nextShiftId : this.state.shift.previousShiftId;
        if (!shiftId || this.navigating)
            return;
        this.navigating = true;
        const swipe = this.swipeRef.current;
        const slidOut = swipe.slideOut(dir);
        Promise.all([FetchHelper.get(`/bpapi/shiftinfo/${shiftId}`), slidOut])
            .then(([result]) => new Promise((resolve) => {
            window.history.replaceState(null, null, qs.stringify({ shiftId: result.shift.id }, { addQueryPrefix: true }));
            this.updateStateAfterLoad(result, () => resolve(swipe.slideIn(dir)));
        }))
            .catch((error) => {
            // The shift that slid out is still the one to show, so it comes back the way it went.
            this.onLoadFailed(error, true);
            return slidOut.then(() => swipe.slideIn(-dir));
        })
            .finally(() => { this.navigating = false; });
    }
    onDateSelectorShown(startDt, endDt) {
        return FetchHelper.get(`/bpapi/shiftinfo/shiftdates?start=${startDt}&end=${endDt}`)
            .then(result => result, _ => null);
    }
    // ---- the parts of the page -------------------------------------------------------------
    navBar() {
        const shift = this.state.shift.shift;
        const shifts = this.state.shift.shiftsOnDay;
        return (React.createElement("nav", { className: "bi-vi-nav", "aria-label": "Naviger i vagtplanen" },
            React.createElement("div", { className: "bi-vi-nav-row" },
                React.createElement("button", { type: "button", className: "bi-vi-step", "aria-label": "Forrige vagt", onClick: () => this.step(-1), disabled: !this.state.shift.previousShiftId },
                    React.createElement(Icon, { size: 20 },
                        React.createElement("path", { d: "m15 6-6 6 6 6" }))),
                React.createElement("div", { className: "bi-vi-date" },
                    React.createElement(DateSelectorComponent, { dt: DateTime.fromISO(shift.dtStart).toFormat("yyyy-MM-dd"), mode: "date", label: `${DateUtility.rowDay(DateTime.fromISO(shift.dtStart))} ${DateTime.fromISO(shift.dtStart).year}`, onDateSelected: (dt) => { this.loadShiftInformationByDate(dt); }, onShow: (startDt, endDt) => this.onDateSelectorShown(startDt, endDt) })),
                React.createElement("button", { type: "button", className: "bi-vi-step", "aria-label": "N\u00E6ste vagt", onClick: () => this.step(1), disabled: !this.state.shift.nextShiftId },
                    React.createElement(Icon, { size: 20 },
                        React.createElement("path", { d: "m9 6 6 6-6 6" })))),
            shifts.length > 0
                ? React.createElement("div", { className: "bi-seg bi-vi-day", role: "group", "aria-label": "Dagens vagter", style: { gridTemplateColumns: `repeat(${shifts.length}, minmax(0, 1fr))` } }, shifts.map((s) => (React.createElement("button", { type: "button", key: s.shiftId, "aria-pressed": s.shiftId === shift.id, onClick: () => this.navigate(s.shiftId) }, DateUtility.rowInterval(DateTime.fromISO(s.dtStart), DateTime.fromISO(s.dtEnd))))))
                : null));
    }
    header(isMine, onExchange) {
        const shift = this.state.shift.shift;
        const start = DateTime.fromISO(shift.dtStart);
        const end = DateTime.fromISO(shift.dtEnd);
        const planned = shift.status === BPShiftStatus.planned;
        return (React.createElement("div", { className: "bi-vi-head" },
            React.createElement("div", { className: "bi-vi-chips" },
                this.state.pastShift
                    ? React.createElement("span", { className: "bi-chip" }, "Afholdt")
                    : React.createElement("span", { className: `bi-chip ${planned ? "bi-chip-planned" : "bi-chip-preplanned"}` },
                        React.createElement("span", { className: `bi-sr-dot ${planned ? "bi-sr-dot-planned" : "bi-sr-dot-preplanned"}` }),
                        planned ? "Planlagt" : "Foreløbig"),
                shift.isRedShift && !this.state.pastShift ? React.createElement("span", { className: "bi-chip bi-chip-urgent" },
                    React.createElement("span", { className: "bi-sr-dot" }),
                    "Haster") : null,
                shift.isYellowShift && !shift.isRedShift && !this.state.pastShift ? React.createElement("span", { className: "bi-chip bi-chip-yellow" }, "Gul vagt") : null,
                isMine ? React.createElement("span", { className: "bi-chip bi-chip-role" }, "Din vagt") : null,
                onExchange
                    ? React.createElement("span", { className: "bi-chip" },
                        React.createElement(Icon, { size: 13, stroke: 2.25 },
                            React.createElement("path", { d: "M7 4 3 8l4 4M3 8h14M17 12l4 4-4 4M21 16H7" })),
                        "Sat til bytte")
                    : null),
            React.createElement("h1", null, DateUtility.longDay(start)),
            React.createElement("div", { className: "bi-vi-time" },
                React.createElement(Icon, { size: 20 },
                    React.createElement("circle", { cx: "12", cy: "12", r: "9" }),
                    React.createElement("path", { d: "M12 7v5l3 2" })),
                DateUtility.rowInterval(start, end)),
            this.notices()));
    }
    // What a shift still lacks: "operatør og 2 kiosk".
    missing() {
        var _a;
        const shift = this.state.shift.shift;
        const missing = [];
        if ((_a = shift.operator) === null || _a === void 0 ? void 0 : _a.isGhost)
            missing.push("operatør");
        const openShops = this.state.shop.filter((m) => m.isGhost).length;
        if (openShops > 0)
            missing.push(`${openShops} kiosk`);
        return missing.join(" og ");
    }
    // A yellow shift is open for volunteers to take; a red one (below) is yellow and close.
    yellowNotice() {
        const shift = this.state.shift.shift;
        if (!shift.isYellowShift || shift.isRedShift || this.state.pastShift)
            return null;
        const missing = this.missing();
        return (React.createElement("div", { className: "bi-vi-yellow" },
            React.createElement(Icon, { size: 22, stroke: 2 },
                React.createElement("path", { d: "M12 3 2 20h20z" }),
                React.createElement("path", { d: "M12 10v4M12 17.5v.5" })),
            React.createElement("div", null,
                React.createElement("strong", null, "Gul vagt"),
                React.createElement("span", null, missing
                    ? `Denne vagt er under planlægning som gul vagt og mangler frivillige: ${missing}.`
                    : "Denne vagt er under planlægning som gul vagt. Alle poster er besat."))));
    }
    // A red shift: starts within 72 hours and is still not staffed. It is said plainly, with what is
    // missing, since this is the shift somebody has to take.
    urgentNotice() {
        const shift = this.state.shift.shift;
        if (!shift.isRedShift || this.state.pastShift)
            return null;
        const missing = this.missing();
        return (React.createElement("div", { className: "bi-vi-urgent", role: "alert" },
            React.createElement(Icon, { size: 22, stroke: 2 },
                React.createElement("path", { d: "M12 3 2 20h20z" }),
                React.createElement("path", { d: "M12 10v4M12 17.5v.5" })),
            React.createElement("div", null,
                React.createElement("strong", null, "Haster: r\u00F8d vagt"),
                React.createElement("span", null, missing
                    ? `Denne vagt afholdes inden for 72 timer og mangler stadig frivillige: ${missing}.`
                    : "Denne vagt afholdes inden for 72 timer. Alle poster er besat."))));
    }
    // The notes of the head share one width, the width of the longer one.
    notices() {
        var _a;
        const shift = this.state.shift.shift;
        const urgent = (_a = this.urgentNotice()) !== null && _a !== void 0 ? _a : this.yellowNotice();
        // A shift that is over is still shown, and says why.
        const preplanned = this.state.pastShift
            ? React.createElement("p", { className: "bi-vi-hint bi-vi-hint-past" }, "Denne vagt er afholdt og vises af historiske \u00E5rsager.")
            : shift.status === BPShiftStatus.preplanned
                ? React.createElement("p", { className: "bi-vi-hint" }, "Vagten er under planl\u00E6gning. Der kan komme \u00E6ndringer i film, antal forestillinger og tidspunkter.")
                : null;
        return urgent || preplanned
            ? React.createElement("div", { className: "bi-vi-notices" },
                urgent,
                preplanned)
            : null;
    }
    /**
     * Whether the volunteer's own shift is on the exchange right now: what the page was loaded with,
     * until the control says it has been put on or taken off.
     */
    onExchange(memberShift) {
        const exchange = this.state.exchanged ? this.state.exchanged.value : memberShift.shiftExchange;
        return !!exchange && exchange.id !== 0;
    }
    swapBar(memberShift) {
        const shift = this.state.shift.shift;
        // The shift goes on and comes off the exchange from here, so the line follows what the
        // component last said rather than what the page was loaded with.
        const exchange = this.onExchange(memberShift);
        // The control swaps places with the text when the shift goes on or comes off the exchange.
        // The keys make React move it rather than mount a new one, which would start over from the
        // exchange the page was loaded with and show the old button.
        const control = (React.createElement(ShiftExchangeComponent, Object.assign({ key: "control", shiftid: shift.id, shiftexchange: memberShift.shiftExchange, variant: "vagtinfo", onsuccess: (shiftExchange) => this.setState({ exchanged: { value: shiftExchange } }) }, udbydSummary(shift, memberShift.role))));
        // On the exchange, what it says comes first and the bar under it; before, the button comes
        // first and the question that sells it under that.
        return exchange
            ? (React.createElement("div", { className: "bi-vi-swap bi-vi-swap-on" },
                React.createElement("p", { key: "text" }, "Vagten er sat til bytte. Kopi\u00E9r linket og del det, s\u00E5 en anden frivillig kan overtage vagten."),
                control))
            : (React.createElement("div", { className: "bi-vi-swap" },
                control,
                React.createElement("p", { key: "text" }, "Kan du ikke alligevel? S\u00E5 kan en anden frivillig overtage vagten.")));
    }
    notes() {
        const notes = this.state.shift.shift.notes;
        if (!notes)
            return null;
        const html = linkifyHtml(DOMPurify.sanitize(notes));
        return (React.createElement("section", { className: "bi-vi-notes" },
            React.createElement("div", { className: "bi-vi-notes-title" },
                React.createElement(Icon, { size: 18, stroke: 2 },
                    React.createElement("path", { d: "M6 3h9l4 4v14H6z" }),
                    React.createElement("path", { d: "M9 12h7M9 16h7" })),
                "Noter til vagten"),
            React.createElement("div", { className: "bi-vi-notes-text", dangerouslySetInnerHTML: { __html: html } })));
    }
    events() {
        const events = this.state.shift.shift.events;
        return (React.createElement("section", { className: "bi-vi-events" },
            React.createElement("h2", null, "Forestillinger"),
            events.length === 0
                ? React.createElement("p", { className: "bi-sl-empty bi-sl-empty-card" }, "Der er ikke planlagt nogen forestillinger")
                : events.map((evt) => {
                    var _a;
                    const start = DateUtility.parse(evt.startTime);
                    const end = DateUtility.parse(evt.endTime);
                    const filmNote = evt.eventContent.notes;
                    const eventNote = evt.notes;
                    const externalId = evt.eventContent.externalId;
                    return (React.createElement("article", { className: "bi-vi-event", key: evt.id },
                        React.createElement("div", { className: "bi-vi-event-top" },
                            React.createElement("span", { className: "bi-vi-poster" },
                                React.createElement("img", { src: `/plakat/?contentId=${evt.eventContent.id}`, alt: "", onError: (e) => { e.currentTarget.style.display = "none"; } }),
                                React.createElement("span", { className: "bi-vi-poster-label" }, "Plakat")),
                            React.createElement("div", { className: "bi-vi-event-title" },
                                React.createElement("span", { className: "bi-vi-event-time" },
                                    start.toFormat("HH:mm"),
                                    "\u2013",
                                    end.toFormat("HH:mm")),
                                React.createElement("h3", null, evt.decoratedTitle))),
                        React.createElement("div", { className: "bi-vi-event-body" },
                            React.createElement("div", { className: "bi-vi-facts" },
                                React.createElement("span", null,
                                    React.createElement("span", { className: "bi-vi-label" }, "Sal"),
                                    React.createElement("strong", null, (_a = evt.venue) === null || _a === void 0 ? void 0 : _a.venueName)),
                                React.createElement("span", null,
                                    React.createElement("span", { className: "bi-vi-label" }, "Start"),
                                    React.createElement("strong", null, start.toFormat("HH:mm"))),
                                React.createElement("span", null,
                                    React.createElement("span", { className: "bi-vi-label" }, "Slut"),
                                    React.createElement("strong", null, end.toFormat("HH:mm"))),
                                React.createElement("span", null,
                                    React.createElement("span", { className: "bi-vi-label" }, "Varighed"),
                                    React.createElement("strong", null,
                                        evt.eventContent.duration,
                                        " min"))),
                            externalId ? React.createElement(TicketBar, { eventId: evt.id }) : null,
                            eventNote
                                ? React.createElement("div", { className: "bi-vi-note" },
                                    React.createElement(Icon, { size: 15, stroke: 2 },
                                        React.createElement("path", { d: "M6 3h9l4 4v14H6z" }),
                                        React.createElement("path", { d: "M9 12h7M9 16h7" })),
                                    React.createElement("span", null,
                                        React.createElement("strong", null, "Note til forestillingen: "),
                                        React.createElement("span", { dangerouslySetInnerHTML: { __html: linkifyHtml(DOMPurify.sanitize(eventNote)) } })))
                                : null,
                            filmNote
                                ? React.createElement("div", { className: "bi-vi-note" },
                                    React.createElement(Icon, { size: 15, stroke: 2 },
                                        React.createElement("path", { d: "M6 3h9l4 4v14H6z" }),
                                        React.createElement("path", { d: "M9 12h7M9 16h7" })),
                                    React.createElement("span", null,
                                        React.createElement("strong", null, "Note til filmen: "),
                                        React.createElement("span", { dangerouslySetInnerHTML: { __html: linkifyHtml(DOMPurify.sanitize(filmNote)) } })))
                                : null,
                            externalId
                                ? React.createElement("a", { className: "bi-vi-link", href: `https://www.hadstenbio.dk/movie_details/${externalId}`, target: "_blank", rel: "noopener noreferrer" },
                                    React.createElement(Icon, { size: 16, stroke: 2 },
                                        React.createElement("path", { d: "M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" })),
                                    "Se filmen p\u00E5 hadstenbio.dk")
                                : null)));
                })));
    }
    crewRow(member, currentMember, isShop) {
        var _a;
        const mine = member.memberId === currentMember.udi;
        const ghost = !!member.isGhost;
        if (ghost) {
            const slug = (_a = member.shiftExchange) === null || _a === void 0 ? void 0 : _a.slug;
            const canTakeOpen = !!slug && currentMember.isAvailable
                && currentMember.roles.includes(member.role) && !this.state.pastShift;
            return (React.createElement("div", { className: "bi-vi-person bi-vi-person-open", key: `open-${member.id}` },
                React.createElement("span", { className: "bi-vi-avatar bi-vi-avatar-open", "aria-hidden": "true" },
                    React.createElement(Icon, { size: 20, stroke: 2 },
                        React.createElement("path", { d: "M12 5v14M5 12h14" }))),
                React.createElement("span", { className: "bi-vi-person-name" }, "Endnu ikke besat"),
                canTakeOpen
                    ? React.createElement("button", { type: "button", className: "bi-btn bi-btn-take", onClick: () => this.setState({
                            confirmTake: {
                                slug,
                                question: tagVagtenQuestion(whenText(this.state.shift.shift.dtStart), member.role),
                                yesLabel: "Ja, tag vagten",
                                yellow: true
                            }
                        }) }, "Tag vagten")
                    : null));
        }
        const canTake = member.shiftExchange && currentMember.isAvailable
            && currentMember.roles.includes(member.role) && !this.state.pastShift && !mine;
        return (React.createElement("div", { className: "bi-vi-person", key: `m-${member.id}` },
            React.createElement("span", { className: `bi-vi-avatar${mine ? " bi-vi-avatar-mine" : ""}`, "aria-hidden": "true" }, MemberDialog.initials(member.name)),
            React.createElement("span", { className: "bi-vi-person-text" },
                React.createElement("button", { type: "button", className: "bi-vi-person-name bi-vi-person-open-btn", onClick: () => this.setState({ selectedMember: member }) },
                    member.name,
                    mine ? " (dig)" : ""),
                member.shiftExchange && !mine ? React.createElement("span", { className: "bi-vi-person-sub" }, "Sat til bytte") : null),
            canTake
                ? React.createElement("button", { type: "button", className: "bi-btn bi-btn-take", onClick: () => this.setState({
                        confirmTake: {
                            slug: member.shiftExchange.slug,
                            question: overtagQuestion(whenText(this.state.shift.shift.dtStart), member.name),
                            yesLabel: "Ja, overtag"
                        }
                    }) }, "Overtag")
                : null,
            isShop
                ? React.createElement(RsvpPill, { member: member, editable: mine && !this.state.pastShift, busy: !!this.state.busyRsvp && mine, onSelect: (rsvp) => this.onUpdateRSVP(member.id, rsvp) })
                : null));
    }
    crew() {
        const shift = this.state.shift.shift;
        const currentMember = this.state.shift.currentMember;
        return (React.createElement("section", { className: "bi-vi-crew" },
            React.createElement("h2", null, "Operat\u00F8r"),
            React.createElement("div", { className: "bi-vi-people" }, shift.operator ? this.crewRow(shift.operator, currentMember, false) : null),
            React.createElement("h2", null, "Kiosk"),
            React.createElement("div", { className: "bi-vi-people" }, this.state.shop.map((member) => this.crewRow(member, currentMember, true)))));
    }
    loadErrorView() {
        const messages = {
            shiftnotfound: 'Vagten blev ikke fundet.',
            noshifts: 'Der er ingen vagter at vise.',
            failed: 'Vagten kunne ikke hentes. Prøv igen om lidt.'
        };
        const error = this.state.loadError;
        return (React.createElement("div", { className: "bi-vi" },
            React.createElement("div", { className: "bi-vi-head" },
                React.createElement("h1", null, "Vagtdetaljer")),
            React.createElement("div", { className: "bi-vi-error" },
                React.createElement("p", null, messages[error]),
                error !== 'noshifts'
                    ? React.createElement("a", { className: "bi-btn bi-btn-primary", href: location.pathname }, "G\u00E5 til den aktuelle vagt")
                    : null)));
    }
    render() {
        if (this.state.isLoaded) {
            const shift = this.state.shift.shift;
            const currentMember = this.state.shift.currentMember;
            const memberShift = _.find(shift.members, (x) => x.memberId === currentMember.udi);
            const isMine = !!memberShift;
            return (React.createElement("div", { className: "bi-vi" },
                this.navBar(),
                React.createElement(SwipeNavigation, { ref: this.swipeRef, onPrevious: () => this.step(-1), onNext: () => this.step(1) },
                    React.createElement("div", { className: `bi-vi-page${this.state.pastShift ? " bi-vi-page-past" : ""}` },
                        this.header(isMine, !!(isMine && !this.state.pastShift && this.onExchange(memberShift))),
                        this.notes(),
                        React.createElement("div", { className: "bi-vi-body" },
                            this.events(),
                            this.crew()),
                        isMine && !this.state.pastShift ? this.swapBar(memberShift) : null)),
                this.state.confirmTake
                    ? React.createElement(AcquireShift, { slug: this.state.confirmTake.slug, question: this.state.confirmTake.question, yesLabel: this.state.confirmTake.yesLabel, yellow: this.state.confirmTake.yellow, onClose: () => this.setState({ confirmTake: null }) })
                    : null,
                this.state.selectedMember
                    ? React.createElement(MemberDialog, { name: this.state.selectedMember.name, phoneNo: this.state.selectedMember.phoneNumber, pictureUrl: MemberDialog.photo(this.state.selectedMember.profilePictureUrl), onClose: () => this.setState({ selectedMember: null }) })
                    : null));
        }
        else if (this.state.loadError) {
            return this.loadErrorView();
        }
        else {
            return (React.createElement("div", { className: "bp-loading" },
                React.createElement("i", { className: "fa fa-spinner fa-pulse fa-fw" })));
        }
    }
}
ReactRenderer.render("shiftinformationcomponent", (elem) => React.createElement(ShiftInformationComponent, Object.assign({}, (elem.dataset))));
